var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-block"}},[_c('el-button',{on:{"click":_vm.removeOrderById}},[_vm._v("删除")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }